import { gql } from "@apollo/client"
import { useMutation } from "@oysterhr/core"
import { RequestReportInput, RequestReportPayload } from "@oysterhr/schema"

const MUTATION = gql`
  mutation BenefitsStaffStartReconciliation($input: RequestReportInput!) {
    requestReconciliationReport(input: $input) {
      reconciliationRun {
        id
        status
        output {
          url
          title
          createdAt
        }
      }
      errors
    }
  }
`

export function useStartBenefitReconciliation() {
  return useMutation<
    {
      requestReconciliationReport: RequestReportPayload
    },
    { input: RequestReportInput }
  >(MUTATION)
}
